import { GETIDENTIFIERSTATE } from '../constants';
import { ReactNode } from 'react';

export const getIdentifierState = (identifierState: string) => {
	return {
		type: GETIDENTIFIERSTATE,
		identifierState,
	};
};
